import { confirmAlert } from 'react-confirm-alert'
import getText from '../../shared/i18n/labels'

// BUTTONS
import { BtnEmpty } from '../BtnEmpty'
import { BtnFill } from '../BtnFill'

/**
 * PopupDelete è un componente che visualizza un popup di conferma dell'eliminazione.
 *
 * @param {string} title - Titolo opzionale per l'avviso. Se non specificato, utilizza un titolo di default in base all'operazione.
 * @param {string} operazione - Testo da utilizzare per l'operazione di eliminazione.
 * @param {string} text - Testo opzionale da visualizzare all'interno del popup.
 * @param {array} list - Elenenco di testi opzionali da visualizzare all'interno del popup.
 * @param {string} cancelText - Testo opzionale per il pulsante di annullamento. Impostato di default su un'etichetta di annullamento.
 * @param {string} confirmText - Testo opzionale per il pulsante di conferma. Impostato di default su un'etichetta di conferma.
 * @param {Function} handleClickConfirm - Funzione di callback opzionale da chiamare quando viene cliccato il pulsante di conferma.
 */
export function PopupDelete(props) {
  const labels = getText(localStorage.getItem('language') || 'it')

  /**
   * confirm alert è una funzione di react-confirm-alert che mostra un popup
   *
   * @see https://github.com/GA-MO/react-confirm-alert
   *
   */
  return confirmAlert({
    /**
     * customUI è una funzione di callback che restituisce un elemento JSX per il contenuto del popup di conferma dell'avviso.
     *
     * La funzione riceve un oggetto con una singola proprietà, onClose, che è una funzione di callback che dovrebbe essere chiamata quando l'utente vuole chiudere il popup.
     * La funzione dovrebbe restituire un elemento JSX che verrà renderizzato all'interno del popup.
     *
     */
    customUI: ({ onClose }) => {
      return (
        <>
          <div className="bar"></div>
          <div className="popup modal-content">
            <div className="w-100 d-flex justify-content-end">
              <button type="button" className="close btn-close" onClick={onClose}>
                <span className="visually-hidden">Close</span>
              </button>
            </div>
            <div className={'row show-grid popup-title-delete text-center font-weight-bold'}>
              <div className="col-12 py-3">
                {props.title ? (
                  <h5>{props.title}</h5>
                ) : (
                  <h4>
                    {labels.DELETE} {props.operazione}
                  </h4>
                )}
              </div>
            </div>
            <div className={'row show-grid text-center'}>
              {props.text ? (
                <div className="col-12">
                  <div className="text-center" dangerouslySetInnerHTML={{ __html: props?.text }} />
                </div>
              ) : (
                ''
              )}

              <div className="col-12">
                {props.list?.map((item, index) => (
                  <div key={index} className="text-center">
                    {item}
                  </div>
                ))}
              </div>
            </div>
            <div className="row pt-4 justify-content-between">
              <BtnEmpty
                classCustom={'col me-3'}
                text={props.cancelText || labels.CANCEL}
                handlerOnClick={onClose}
              />
              <BtnFill
                classCustom={'col d-flex justify-content-end'}
                text={props.confirmText || labels.CONFIRM}
                handlerOnClick={() => {
                  props.handleClickConfirm()
                  onClose()
                }}
              />
            </div>
          </div>
        </>
      )
    },
    closeOnClickOutside: false
  })
}
